import {
  buildInProgressDailyAttempt,
  normalizeDailyAttempt,
} from './dailyGameAttemptUtils';

const DAILY_GUEST_STORAGE_KEY = 'zoomedInDailyGuestAttempt';

const parseGuestPayload = () => {
  try {
    const raw = localStorage.getItem(DAILY_GUEST_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch (error) {
    console.error('[daily] Failed to read guest daily attempt:', error);
    return null;
  }
};

export const getGuestDailyAttempt = (puzzleDateUtc) => {
  if (!puzzleDateUtc) return null;
  const payload = parseGuestPayload();
  if (!payload) return null;
  if (String(payload.puzzleDateUtc) !== String(puzzleDateUtc)) return null;
  return normalizeDailyAttempt(payload.attempt);
};

export const getGuestDailyAttemptRecord = () => {
  const payload = parseGuestPayload();
  if (!payload?.puzzleDateUtc) return null;
  return {
    puzzleDateUtc: String(payload.puzzleDateUtc),
    attempt: normalizeDailyAttempt(payload.attempt),
    updatedAt: payload.updatedAt ? String(payload.updatedAt) : null,
  };
};

export const saveGuestDailyAttempt = ({ puzzleDateUtc, attempt }) => {
  if (!puzzleDateUtc) return false;
  try {
    localStorage.setItem(
      DAILY_GUEST_STORAGE_KEY,
      JSON.stringify({
        puzzleDateUtc: String(puzzleDateUtc),
        attempt: normalizeDailyAttempt(attempt),
        updatedAt: new Date().toISOString(),
      }),
    );
    return true;
  } catch (error) {
    console.error('[daily] Failed to save guest daily attempt:', error);
    return false;
  }
};

export const ensureGuestDailyAttempt = ({ puzzleDateUtc, gameState }) => {
  if (!puzzleDateUtc) return null;
  const existing = getGuestDailyAttempt(puzzleDateUtc);
  if (existing) return existing;

  const fresh = buildInProgressDailyAttempt(gameState);
  saveGuestDailyAttempt({ puzzleDateUtc, attempt: fresh });
  return fresh;
};

export const clearGuestDailyAttempt = ({ puzzleDateUtc } = {}) => {
  try {
    if (!puzzleDateUtc) {
      localStorage.removeItem(DAILY_GUEST_STORAGE_KEY);
      return true;
    }
    const payload = parseGuestPayload();
    if (!payload) return false;
    if (String(payload.puzzleDateUtc) !== String(puzzleDateUtc)) return false;
    localStorage.removeItem(DAILY_GUEST_STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('[daily] Failed to clear guest daily attempt:', error);
    return false;
  }
};
